import styled, { css } from "styled-components";

import { COLORS } from "@treelab/panda";

export const DropdownDivider = styled.div``;

export const ChildrenMixin = css`
  margin-bottom: 8px;
  position: relative;

  #panda-dropdown-menu {
    padding-bottom: 4px;
  }

  .panda-input-dropdown--input {
    padding-top: 6px;
    padding-bottom: 6px;
  }

  #panda-search-input {
    padding-left: 12px !important;
    width: calc(100% - 10px);
    border: none;
    outline: none;
    background-color: transparent !important;
  }

  input:focus-visible {
    outline: none;
  }
`;

export const ChildrenErrorMixin = css`
  ${ChildrenMixin};

  & .panda-input-dropdown--input {
    // 因为该 div 有 border-radius border-radius 会影响 box-shadow 进而作出不挤占空间的红框
    box-shadow: 0 0 0 1px ${COLORS.red};
  }
`;

export const ChildrenUndefinedMixin = css`
  ${ChildrenMixin};

  color: blue;

  & .panda-input-dropdown--input {
    color: ${COLORS.greyLight1};
  }
`;

export const Container = styled.div``;

export const OptionContainer = styled.div`
  font-size: 12px;
  line-height: 32px;
  color: ${COLORS.grey};

  & > div {
    margin: 4px 0;
  }

  & > span {
    padding: 0 16px;
  }
`;

export const ErrorContainer = styled.div`
  height: 20px;
  & > :first-child {
    margin-top: 4px;
    margin-left: 8px;
    font-size: 12px;
    font-weight: normal;
    line-height: 18px;
    color: ${COLORS.red};
  }
`;

export const IconContainer = styled.div`
  position: absolute;
  right: 32px;
  top: 6px;
  color: ${COLORS.greyLight1};
  cursor: pointer;
`;
